import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-remove-market-profile-dialog',
  templateUrl: './remove-market-profile-dialog.component.html',
  styleUrls: ['./remove-market-profile-dialog.component.scss']
})
export class RemoveMarketProfileDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<RemoveMarketProfileDialogComponent>,

    @Inject(MAT_DIALOG_DATA) public data: {
      id: string,
      name: string
    },
  ) {}

  onConfirm(id: string) {
    this.dialogRef.close({ id: id });
  }
}
